import { useCallback } from 'react';

import {
  DEFAULT_BLOG_NAME,
  DEFAULT_DOCUMENT_NAME,
  isBlogPostProjectType,
  isDocumentProjectType,
  isLongFormProjectType,
  isWtmProjectType,
} from 'src/data/project';
import { useErrorHandler } from 'src/services/useErrorHandler';
import { useProjectActions, useProjectFolderActions } from 'src/store';
import { useProjectSettingsPopup } from 'src/views/ProjectSettingsPopup';

import { usePageActions } from '../store';

const isDefaultProjectName = (project) => {
  if (isDocumentProjectType(project?.type) || isLongFormProjectType(project?.type)) {
    return project.name === DEFAULT_DOCUMENT_NAME;
  }

  if (isBlogPostProjectType(project?.type)) {
    return project.name === DEFAULT_BLOG_NAME;
  }
};

export const useUpdateProject = ({ isDisplayedBeforeGoBack, onConfirm, onCancel } = {}) => {
  const openProjectSettingsPopup = useProjectSettingsPopup();
  const handleError = useErrorHandler();
  const projectActions = useProjectActions();
  const pageActions = usePageActions();
  const projectFolderActions = useProjectFolderActions();

  /**
   * Handle project name change action
   */
  return useCallback(() => {
    const project = projectActions.getCurrentProject();
    const oldName = pageActions.getProjectName();
    const projectSuggestedTitle = projectActions.getProjectSuggestedTitle();

    openProjectSettingsPopup({
      isDisplayedBeforeGoBack,
      name: isDefaultProjectName(project) ? projectSuggestedTitle || oldName : oldName,
      projectFolderId: project.projectFolder?.id,
      isDocument: isDocumentProjectType(project?.type),
      displayMoveToFolder: !isWtmProjectType(project?.type),
      displayName: true,
      onConfirm: async ({ name, projectFolderId }) => {
        try {
          pageActions.setProjectName(name);
          await projectActions.updateProject({ id: project?.id, name, projectFolderId });
          await projectFolderActions.decreaseFolderProjectCount(project.projectFolder?.id);
          await projectFolderActions.increaseFolderProjectCount(projectFolderId);

          if (onConfirm) {
            await onConfirm();
          }
        } catch (error) {
          pageActions.setProjectName(oldName);
          handleError(error);
        }
      },
      onCancel,
    });
  }, [
    projectActions,
    pageActions,
    openProjectSettingsPopup,
    isDisplayedBeforeGoBack,
    projectFolderActions,
    onConfirm,
    handleError,
    onCancel,
  ]);
};
